export default {
  backgroundTheme: {
    default: 'colors/backgrounds/default',
    payment_calculator: 'colors/backgrounds/subtle-inline',
    'payment-information-generic-interstitial': 'colors/backgrounds/subtle-inline',
    'payment-calculator-interstitial': 'colors/backgrounds/subtle-inline',
    'deals-interstitial': 'colors/backgrounds/subtle-inline',
    'payment-calculator-interstitial-revamped': 'colors/backgrounds/default',
    external_content: 'colors/backgrounds/subtle-inline',
    checkout: 'colors/backgrounds/subtle-inline',
    frame_component: 'colors/backgrounds/default',
    frame_component_revamped: 'colors/borders/subtle-surface',
    badgeColor: 'colors/backgrounds/accent-inline',
    badgeTextColor: 'colors/text/subtle',
    fallback: 'colors/backgrounds/subtle-inline',
    sibcProgressBackground: 'colors/backgrounds/subtle-inline'
  },
  darkBackgroundTheme: {
    default: 'colors/backgrounds/default',
    payment_calculator: 'colors/backgrounds/default',
    'payment-information-generic-interstitial': 'colors/backgrounds/default',
    'payment-calculator-interstitial': 'colors/backgrounds/default',
    'deals-interstitial': 'colors/backgrounds/default',
    external_content: 'colors/backgrounds/default',
    checkout: 'colors/backgrounds/default',
    frame_component: 'colors/backgrounds/subtle-inline',
    frame_component_revamped: 'colors/borders/subtle-surface',
    badgeColor: 'colors/borders/accent',
    badgeTextColor: 'colors/text/inverse',
    fallback: 'colors/backgrounds/default',
    sibcProgressBackground: 'colors/backgrounds/default'
  },
  paymentMethods: [
    { name: 'SLICE_IT_BY_CARD', illustration: 'IconScissors' },
    { name: 'INVOICE', illustration: 'IconCalendar' },
    { name: 'PAY_LATER_BY_CARD', illustration: 'IconCalendar' },
    { name: 'FIXED_SUM_CREDIT', illustration: 'IconHourglass' },
    { name: 'PAY_BY_CARD', illustration: 'IconTransfer' }
  ]
}
